import React, { useState, useEffect, useCallback } from "react";
import {
  Box,
  Typography,
  Paper,
  Button,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { useAuth } from "../../providers/AuthProvider";
import { useNotification } from "../../providers/NotificationProvider";
import { fetchPlaceCategories } from "../../api/memberApi";

export default function PlaceCategoryListPage() {
  const { businessDomainId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const { companyId } = useAuth();
  const t = (id) => intl.formatMessage({ id });
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      const data = await fetchPlaceCategories(companyId);
      setItems(Array.isArray(data) ? data : []);
    } catch (e) {
      notify.apiError(e);
    } finally {
      setLoading(false);
    }
  }, [companyId]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    loadData();
  }, [loadData]);

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", mb: 3, gap: 2 }}>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(`/strategy/${businessDomainId}`)}
          variant="text"
        >
          {t("common.back")}
        </Button>
        <Typography variant="h5" sx={{ fontWeight: 600 }}>
          {t("placeCategory.list.title")}
        </Typography>
      </Box>
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 6 }}>
          <CircularProgress />
        </Box>
      ) : items.length === 0 ? (
        <Typography color="text.secondary">{t("common.noData")}</Typography>
      ) : (
        <TableContainer component={Paper} variant="outlined">
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: "grey.50" }}>
                <TableCell sx={{ fontWeight: 600 }}>{t("placeCategory.name")}</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>{t("placeCategory.placeType")}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items.map((row) => (
                <TableRow
                  key={row.placeCategoryId}
                  hover
                  sx={{ cursor: "pointer" }}
                  onClick={() =>
                    navigate(`/strategy/${businessDomainId}/place-categories/${row.placeCategoryId}`)
                  }
                >
                  <TableCell>{row.placeCategoryName || "—"}</TableCell>
                  <TableCell>{row.placeTypeName || "—"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}
